import { redirect } from "react-router-dom";
import { DefaultLayout } from "@layouts/DefaultLayout";

// Page imports
import { TwoFactorPage } from "@pages/account/TwoFactorPage";
import AdminPortal from "@pages/AdminPortal";
import AuthPage from "@pages/Auth/AuthPage";
import { CreateGiftBatch } from "@pages/gifts/CreateGiftBatch";
import { GiftDetail } from "@pages/gifts/GiftDetail";
import { GiftsList } from "@pages/gifts/GiftsList";
import { HealthPage } from "@pages/health/HealthPage";
import ProductCatalog from "@pages/ProductCatalog/ProductCatalog";
import AllTransactions from "@pages/transactions/AllTransactions";
import LegacyTransactionDetail from "@pages/transactions/LegacyTransactionDetail";
import NeedsAttention from "@pages/transactions/NeedsAttention";
import TransactionDetail from "@pages/transactions/TransactionDetail";
import Transactions from "@pages/transactions/transactions";
import { User } from "@pages/v2/User";
import { UserList } from "@pages/v2/UsersList";
import { UploadVideo } from "@pages/videos/UploadVideo";

export const AUTH_ROUTES = [
  "/login",
  "/signup",
  "/forgot-password",
  "/set-password",
  "/reset-password",
];

export const LOGOUT_ROUTES = ["/logout"];

export const routes = [
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      {
        element: <AuthPage />,
        children: [
          ...AUTH_ROUTES.map((route) => ({
            path: route,
          })),
          ...LOGOUT_ROUTES.map((route) => ({
            path: route,
            element: null,
          })),
        ],
      },
      {
        path: "",
        element: <AdminPortal />,
        children: [
          {
            index: true,
            loader: () => {
              return redirect("/users");
            },
          },
          {
            path: "users",
            children: [
              {
                index: true,
                element: <UserList />,
              },
              {
                path: ":userId",
                element: <User />,
              },
            ],
          },
          {
            path: "gifts",
            children: [
              {
                index: true,
                element: <GiftsList />,
              },
              {
                // Static segment is ranked above ":giftId" by react-router.
                path: "batch",
                element: <CreateGiftBatch />,
              },
              {
                path: ":giftId",
                element: <GiftDetail />,
              },
            ],
          },
          {
            path: "transactions",
            element: <Transactions />,
            children: [
              {
                index: true,
                loader: () => redirect("/transactions/needs-attention"),
              },
              {
                path: "needs-attention",
                element: <NeedsAttention />,
              },
              {
                path: "all",
                element: <AllTransactions />,
              },
              {
                path: "legacy/:transactionId",
                element: <LegacyTransactionDetail />,
              },
              {
                path: ":transactionId",
                element: <TransactionDetail />,
              },
            ],
          },
          {
            path: "product-catalog",
            element: <ProductCatalog />,
          },
          {
            path: "videos",
            element: <UploadVideo />,
          },
          {
            path: "checkout",
            // Lazy: the chart library only loads for this page.
            lazy: async () => ({
              Component: (await import("@pages/checkout/CheckoutPage"))
                .CheckoutPage,
            }),
          },
          {
            path: "health",
            element: <HealthPage />,
          },
          {
            path: "two-factor",
            element: <TwoFactorPage />,
          },
        ],
      },
    ],
  },
  {
    path: "*",
    loader: async () => {
      return redirect("/");
    },
  },
];
